export const LEGACY_MY_CIRCLE_ROUTE_PATH = '/my-circle';

const MY_ROUTE_PATH = '/my';

export const ROUTE_PATH_NAMES = {
  ROOT: '/',
  ASSET: '/asset/:assetId',
  ASSET_CREATE_UPDATE: '/asset/post',
  LOGIN: '/login',
  CHAT: '/chat/:conversationId',
  CHAT_ACTIVITIES: '/chat/:conversationId/activities',
  GROUP_CHAT_DETAILS: '/chat/:conversationId/group-details',
  GROUP_CHAT_INFO_EDIT: '/chat/:conversationId/group-info-edit',
  CHATS: '/chats',
  SOCIAL_CHAT: '/social-chat/:conversationId',
  SOCIAL_CHAT_PENDING: '/social-chat',
  USER_PROFILE: '/user/:username',
  CURRENT_USER_PROFILE: '/hi',
  EXCHANGES_HISTORY: '/exchanges-history',
  EXCHANGE: '/exchange/:exchangeId',
  SEARCH: '/search',
  HUB: '/hub',
  MY_CIRCLE: MY_ROUTE_PATH,
  MY_CIRCLE_NOTES: `${MY_ROUTE_PATH}/notes`,
  MY_CIRCLE_ACTIVITIES: `${MY_ROUTE_PATH}/activities`,
  MY_CIRCLE_ACTIVITY_SECTION: `${MY_ROUTE_PATH}/activity-section/:section`,
  MY_CIRCLE_ADD_BY_USERNAME: `${MY_ROUTE_PATH}/add-by-username`,
  MY_CIRCLE_COMPLETED_TASKS: `${MY_ROUTE_PATH}/completed-tasks`,
  MY_CIRCLE_CONTACT_REQUESTS: `${MY_ROUTE_PATH}/contact-requests`,
  MY_CIRCLE_GROUPS: `${MY_ROUTE_PATH}/groups`,
  MY_CIRCLE_LIST: `${MY_ROUTE_PATH}/list/:listId`,
  MY_CIRCLE_NEW_GROUP_NAME: `${MY_ROUTE_PATH}/new-group-name`,
  MY_CIRCLE_NEW_GROUP: `${MY_ROUTE_PATH}/new-group`,
  MY_CIRCLE_NEW_MESSAGE: `${MY_ROUTE_PATH}/new-message`,
  MY_CIRCLE_SEARCH_CONTACTS: `${MY_ROUTE_PATH}/search-contacts`,
  MY_CIRCLE_TASK: `${MY_ROUTE_PATH}/task`,
  MY_CIRCLE_TASK_DETAIL: `${MY_ROUTE_PATH}/task/:taskId`,
  ACCOUNT_SETTINGS: '/account-settings',
  RESET_PASSWORD: '/reset-password/:token',
  SIGN_IN_COMPLETE: '/sign-in-complete',
  NOTIFICATIONS: '/notifications',
  ASSET_WAVES: '/asset-waves',
  SOCIAL_ACTIVITY: '/social-activities/:activityId',
  SOCIAL_ACTIVITY_CREATE: '/social-activities/create',
  ACTIVITY_EXPENSES: '/expenses/activity',
  ACTIVITY_EXPENSE_EDITOR: '/expenses/edit',
  PLANNING_LIST_SHARE: '/planning/list-share/:listId',
  PLANNING_SHARED_TASKS: '/planning/shared-tasks',
  CLUBS: '/clubs',
  CLUB_DETAIL: '/clubs/:clubId',
  CLUB_ACTIVITY: '/clubs/:clubId/activities/:activityId',
  CLUB_ACTIVITY_CREATE: '/clubs/:clubId/activities/create',
  CLUB_ACTIVITY_PHOTOS: '/clubs/:clubId/activities/:activityId/photos',
  CLUB_ALL: '/clubs/all',
  CLUB_CREATE_INTRO: '/clubs/create-intro',
  CLUB_CREATE: '/clubs/create',
  CLUB_JOIN: '/clubs/join/:inviteCode',
  CLUB_MEMBERS: '/clubs/:clubId/members',
  CLUB_SETTINGS: '/clubs/:clubId/settings',
  INVITE: '/invite/:inviteCode',
  DOWNLOAD: '/dl',
  APPLE_CALLBACK: '/auth/apple/callback',

  // Phone verification routes
  PHONE_VERIFICATION_ENTRY: '/auth/phone-verification/phone-number-entry',
  PHONE_VERIFICATION_CODE: '/auth/phone-verification/verification-code-entry',
  PHONE_VERIFICATION_SUCCESS: '/auth/phone-verification/verification-success',

  // Email verification route
  EMAIL_SIGNUP: '/auth/email-signup',

  // Legal pages
  PRIVACY_POLICY: '/privacy',
  TERMS_OF_CONDITIONS: '/tos',
  CHILD_SAFETY: '/child-safety',
  HELP_CENTER: '/help',
};

export const DEFAULT_AUTHENTICATED_APP_ROUTE = ROUTE_PATH_NAMES.MY_CIRCLE;

export const isLocationPathMatchingRoute = ({
  currentPath,
  routePath,
}: {
  currentPath: string | undefined;
  routePath: string | undefined;
}): boolean => {
  if (!currentPath || !routePath) {
    return false;
  }

  const modifiedPattern = routePath.replace(/:[^\s/]+/g, '([\\w-]+)');
  const regex = new RegExp(`^${modifiedPattern}$`);
  return regex.test(currentPath);

  // TODO: TRY something like this in the future or whatever the proper built in way like:
  // Use React Router's official matcher with exact (end) matching.
  // This mirrors how the router resolves routes and avoids brittle regex.
  // return Boolean(
  //   matchPath(
  //     { path: routePath, end: true, caseSensitive: false },
  //     currentPath,
  //   ),
  // );
};
